import { GridItem, HStack } from "@reverb-ui/react";

type FooterTableProps = {
  children: React.ReactNode;
};

export const DayPartingFooterTable = ({ children }: FooterTableProps) => {
  return (
    <GridItem rowSpan={1} colSpan={7} rowStart={25} colStart={2}>
      <HStack width="full" justifyContent="space-between">
        {children}
      </HStack>
    </GridItem>
  );
};
